import { Navigate } from 'react-router-dom'
import { useAccount } from '../hooks/useAccount'
import type { ReactNode } from 'react'
import { Box, CircularProgress } from '@mui/material'

interface Props {
  children: ReactNode
}

/**
 * Guards a route to admin-only access.
 * Redirects to /dashboard if the user is not an ADMIN.
 */
export default function RequireAdmin({ children }: Props) {
  const { data: user, isLoading } = useAccount()

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress />
      </Box>
    )
  }

  if (!user || user.role !== 'ADMIN') {
    return <Navigate to="/dashboard" replace />
  }

  return <>{children}</>
}
